export enum UnitOfMeasure {
  W = 'W',
  KW = 'kW',
  WH = 'Wh',
  KWH = 'kWh'
}
